import React, { useState } from 'react';
import { Users, UserPlus, Plus, Minus, HelpCircle, Scale, FileText, Phone } from 'lucide-react';
import WhatsAppIcon from '../components/WhatsAppIcon';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const FAQPage = () => {
  const [openQuestion, setOpenQuestion] = useState(null);

  const toggleQuestion = (index) => {
    setOpenQuestion(openQuestion === index ? null : index);
  };

  const faqData = [
    {
      question: "ما هي الدعاوى المشمولة في التكاليف القضائية؟",
      answer: "1. الدعاوى التجارية.\n2. الدعاوى العمالية (الشركات).\n3. الدعاوى الجزائية (الحق الخاص).\n4. طلبات التنفيذ والمنازعات التنفيذية."
    },
    {
      question: "هل يمكن هبة جزء من العقار لشخص او عدة اشخاص؟",
      answer: "نعم (منصة بورصة)."
    },
    {
      question: "هل يمكن اضافة وارث ليس لديه اثبات هوية في طلب توثيق ورثة متوفى؟",
      answer: "لا يمكن، يجب تصحيح وضع الوارث (سواء مواطن او مقيم)."
    },
    {
      question: "هل يكتفى بصك الحضانة أم يلزم إصدار أمر لإصدار صك ولاية لإنهاء جميع الإجراءات المتعلقة بالقصر؟",
      answer: "الأصل أن صك الحضانة كاف لمراجعة جميع الجهات وإنهاء الإجراءات الخاصة بالمحضون وقد يستلزم الأمر صك ولاية للبيع والشراء."
    },
    {
      question: "هل يمكن تقديم طلب نفقة لصندوق النفقة في حال كان المدعى عليه خارج المملكة وصدر بحقه حكم؟",
      answer: "لا يدعم صندوق النفقة المستفيدين في حال كان المستفيد او المحكوم عليه بدفع النفقة خارج المملكة."
    },
    {
      question: "ما هو الحد الأقصى لقيمة النفقة التي يصرفها صندوق النفقة؟",
      answer: "تصرف النفقة وفقاً لما ورد في الحكم القضائي."
    },
    {
      question: "هل يمكن الاعتراض على التكاليف القضائية؟",
      answer: "نعم، خلال ١٥ يوم من تاريخ تبليغه."
    },
    {
      question: "هل هناك احكام تجارية لا يقبل الاعتراض عليها؟",
      answer: "نعم الدعاوى اليسيرة التي لا تزيد قيمة المطالبة الاصلية فيها عن ٥٠ ألف."
    },
    {
      question: "أنا صاحب مؤسسة وأمتلك علامة تجارية وقامت مؤسسة أخرى بالاعتداء على علامتي التجارية فما هو الحل؟",
      answer: "التقدم بشكوى إلى الإدارة العامة لمكافحة الغش التجاري كونها الجهة المختصة بضبط المخالفة استناداً لنظام مكافحة الغش التجاري."
    },
    {
        question: "هل يصح إقامة دعوى ضد فرع شركة أو جمعية أو مؤسسة؟",
        answer: "يصح ذلك، بشرط أن تكون الدعوى متعلقة بذلك الفرع (المادة 28) من نظام المرافعات الشرعية."
    },
    {
        question: "اشتريت سيارة بنظام الإيجار المنتهي بالتمليك وقامت الشركة بسحبها وبيعها وأريد أن أقيم دعوى ضدها من المختص بنظرها؟",
        answer: "إذا كانت الشركة المدعى عليها مرخصة من مؤسسة النقد بمزاولة الإيجار التمويلي، فالمحاكم التجارية هي المختصة بنظر هذه الدعوى، وتختص لجنة الفصل في المخالفات والمنازعات التمويلية بنظرها."
    },
    {
        question: "اتفقت مع مكتب على استقدام خادمة، ولكنه لم يلتزم بذلك وأرغب في إعادة المبلغ، من المختص؟",
        answer: "تختص المحاكم العامة بنظر الدعوى المقامة ضد مكاتب الاستقدام، تعميم 1077 لعام 1439هـ."
    },
    {
        question: "زوجي أخبر والدي بأنه طلقني، وأنا معلقة منذ سنة ولا أعلم عن تفاصيل طلاقي وهل راجعني، ما هي الدعوى التي أتقدم بها قبل أي محكمة؟",
        answer: "بإمكانك التقدم بدعوى إثبات طلاق، لدى محكمة الأحوال الشخصية في البلد الذي تقيمين فيه."
    },
    {
        question: "أريد أن أستخرج صك ولاية لأخي الأصغر (16 سنة) هل يتطلب حضوره؟ وهل مطلوب شهود ومن أين أستخرجها، وشكراً جزيلاً؟",
        answer: "صك الولاية لا يُستخرج إلا لمن هو دون سن الخامسة عشرة."
    },
    {
        question: "هل تستطيع الزوجة إصدار صك طلاق بدل مفقود علماً بأن لديها صورة منه؟",
        answer: "نعم تستطيع الزوجة ذلك وتراجع الدائرة مصدرة الصك."
    },
    {
        question: "هل يحق لصاحب العمل اجباري على توقيع تنازل عن المستحقات الخاصة بي أثناء عقد العمل؟",
        answer: "لا يحق له ذلك."
    },
    {
        question: "هل يستحق الطرف المتضرر تعويضا في حال انهاء عقد العمل في حال إنهاء عقد العمل لسبب غير مشروع؟",
        answer: "نعم يستحق التعويض بموجب المادة 77 من نظام العمل."
    },
    {
        question: "هل يوجد فرق عند احتساب مكافأة الخدمة بين عقد محدد المدة وغير محدد المدة؟",
        answer: "نعم يوجد فرق."
    },
    {
        question: "ما هي المدة التي يستطيع العامل خلالها رفع دعوى بحق من حقوقه؟",
        answer: "خلال 12 شهراً من تاريخ انتهاء علاقة العمل، وإلا قد تسقط حقه في المطالبة."
    },
    {
      question: "ما هي مدة صرف تعويض منفعة الأمومة من التأمينات الاجتماعية؟ وهل توجد حالات يمكن تمديدها؟",
      answer: "يصرف تعويض منفعة الأمومة لمدة (3) أشهر ويمدد صرف التعويض شهراً إضافياً في حال انجاب طفل مريض أو من ذوي الإعاقة وتتطلب حالته الصحية مرافقاً مستمراً له."
    },
    {
      question: "كيف يتم حساب التكاليف القضائية إذا انتهت الدعوى بالصلح؟",
      answer: "يتحمل أطراف الدعوى التكاليف القضائية بالتساوي، ما لم يتفق على غير ذلك."
    },
    {
      question: "ما هي الحالات التي لا تستحق دفع تكاليف قضائية؟",
      answer: "1. إذا حكم بعدم الاختصاص فلا تستحق تكاليف جديدة لإقامة الدعوى أمام المحكمة المختصة ما لم يتغير موضوع الدعوى.\n2. إذا قضت المحكمة المختصة بنقض الحكم وإعادته الدعوى إلى المحكمة التي أصدرت الحكم المعترض عليه إلى المحكمة أو إلى أي محكمة أخرى."
    },
    {
      question: "إذا لم يكن عقد العمل مكتوب هل تعد العلاقة العمالية قائمة؟",
      answer: "نعم تعتبر العلاقة العمالية قائمة إذا كان العامل يعمل لدى صاحب العمل وتحت اشرافه ومتابعته مقابل أجر، ولا يلزم وجود عقد عمل."
    },
    {
      question: "هل يجرى بيع عقار ومن ضمن الورثة شخص قاصر وولده الثالث تنازلت عن نصيبه بموجب صك الولاية؟",
      answer: "للتصرف في العقار وضمن ملاكه قاصر والولي غير والده (وليه الجبري) لا بد من إذن القاضي قبل ذلك، للمادة (224) من نظام المرافعات الشرعية."
    },
     {
      question: "في حال انتهاء السجل التجاري الخاص بالشركة، هل سيتم تعطيل حساب الشركة في مواقع الجهات الرسمية؟ وما هي الطريقة الصحيحة لإعادة التفعيل؟",
      answer: "الحساب العام لا يتم تعطيله إلا في حالة واحدة فقط وهي الحالة التي يتم فيها شطب السجل التجاري للمنشأة."
    }
];

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a3a23]/10 via-white to-[#0a3a23]/5" dir="rtl">
      
      {/* Header */}
      <Header />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] py-12 sm:py-24 overflow-hidden mt-20">
        {/* Background Pattern */}
        <div className="absolute inset-0 bg-black opacity-40"></div>
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='7' cy='7' r='5'/%3E%3Ccircle cx='53' cy='7' r='5'/%3E%3Ccircle cx='30' cy='30' r='5'/%3E%3Ccircle cx='7' cy='53' r='5'/%3E%3Ccircle cx='53' cy='53' r='5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
        
        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 text-center text-white">
          <HelpCircle className="w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-4 sm:mb-6 opacity-80" />
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 text-white">الأسئلة الشائعة</h1>
          <div className="w-16 sm:w-24 h-1 bg-[#0a3a23] mx-auto mb-4 sm:mb-6"></div>
          <p className="text-base sm:text-lg md:text-xl opacity-90 max-w-2xl sm:max-w-3xl mx-auto px-4 text-white">
            إجابات واضحة ومباشرة على أكثر الأسئلة القانونية شيوعاً لمساعدتك في فهم حقوقك والإجراءات القانونية
          </p>
        </div>
      </div>

      {/* FAQ Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-16">
        <div className="grid lg:grid-cols-3 gap-6 sm:gap-12">
          
          {/* FAQ Questions - Now on the Left */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg overflow-hidden">
              <div className="p-4 sm:p-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white">
                <h2 className="text-xl sm:text-2xl font-bold text-white">الأسئلة والأجوبة</h2>
                <p className="opacity-90 mt-1 sm:mt-2 text-sm sm:text-base text-white">اضغط على أي سؤال لعرض الإجابة</p>
              </div>
              
              <div className="divide-y divide-gray-200">
                {faqData.map((faq, index) => (
                  <div key={index} className="border-b border-gray-100 last:border-b-0">
                    <button
                      onClick={() => toggleQuestion(index)}
                      className="w-full px-4 sm:px-6 py-4 sm:py-5 text-right hover:bg-[#0a3a23]/10 transition-colors focus:outline-none focus:bg-[#0a3a23]/10"
                    >
                      <div className="flex items-center justify-between">
                        <span className="text-base sm:text-lg font-semibold text-gray-900 flex-1">
                          {faq.question}
                        </span>
                        <div className="mr-2 sm:mr-4 flex-shrink-0">
                          {openQuestion === index ? (
                            <Minus className="w-5 h-5 sm:w-6 sm:h-6 text-[#0a3a23]" />
                          ) : (
                            <Plus className="w-5 h-5 sm:w-6 sm:h-6 text-gray-400" />
                          )}
                        </div>
                      </div>
                    </button>
                    
                    {openQuestion === index && (
                      <div className="px-4 sm:px-6 pb-4 sm:pb-5 animate-in slide-in-from-top-2 duration-200">
                        <p className="text-sm sm:text-base text-gray-700 leading-relaxed bg-[#0a3a23]/10 p-3 sm:p-4 rounded-lg" style={{ whiteSpace: 'pre-line' }}>
                          {faq.answer}
                        </p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Sidebar Images - Now on the Right */}
          <div className="hidden lg:block space-y-6 sm:space-y-8">
            <div className="bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300">
              <img 
                src="/images/FAQ/FAQ1.png" 
                alt="قاعة محكمة" 
                className="w-full h-48 sm:h-56 object-cover hover:scale-105 transition-transform duration-300"
              />
              <div className="p-4 sm:p-6 text-center bg-gradient-to-b from-[#0a3a23]/5 to-white">
                <h3 className="text-lg sm:text-xl font-bold text-[#0a3a23] mb-2 sm:mb-3 drop-shadow-sm">العدالة والقانون</h3>
                <p className="text-sm sm:text-base text-gray-700 font-medium">نسعى لتحقيق العدالة وحماية حقوقك</p>
              </div>
            </div>
            
            <div className="bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300">
              <img 
                src="/images/FAQ/FAQ2.png" 
                alt="استشارة قانونية" 
                className="w-full h-48 sm:h-56 object-cover hover:scale-105 transition-transform duration-300"
              />
              <div className="p-4 sm:p-6 text-center bg-gradient-to-b from-[#0a3a23]/5 to-white">
                <h3 className="text-lg sm:text-xl font-bold text-[#0a3a23] mb-2 sm:mb-3 drop-shadow-sm">الاستشارات القانونية</h3>
                <p className="text-sm sm:text-base text-gray-700 font-medium">خبرة قانونية متخصصة في جميع المجالات</p>
              </div>
            </div>
            
            <div className="bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300">
              <img 
                src="/images/صور الموقع (1)/15.jpg" 
                alt="خدمات قانونية" 
                className="w-full h-48 sm:h-56 object-cover hover:scale-105 transition-transform duration-300"
              />
              <div className="p-4 sm:p-6 text-center bg-gradient-to-b from-[#0a3a23]/5 to-white">
                <h3 className="text-lg sm:text-xl font-bold text-[#0a3a23] mb-2 sm:mb-3 drop-shadow-sm">خدمات قانونية متكاملة</h3>
                <p className="text-sm sm:text-base text-gray-700 font-medium">نقدم جميع الخدمات القانونية تحت سقف واحد</p>
              </div>
            </div>
            
            <div className="bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300">
              <img 
                src="/images/صور الموقع (1)/16.jpg" 
                alt="مكتب محاماة" 
                className="w-full h-48 sm:h-56 object-cover hover:scale-105 transition-transform duration-300"
              />
              <div className="p-4 sm:p-6 text-center bg-gradient-to-b from-[#0a3a23]/5 to-white">
                <h3 className="text-lg sm:text-xl font-bold text-[#0a3a23] mb-2 sm:mb-3 drop-shadow-sm">مكتب محاماة معتمد</h3>
                <p className="text-sm sm:text-base text-gray-700 font-medium">نحظى بثقة العملاء والجهات الرسمية</p>
              </div>
            </div>
          </div>
          
        </div>
      </div>



      {/* Floating Contact Buttons */}
      <a
        href="tel:920033053"
        className="fixed bottom-20 sm:bottom-28 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/966115115945?text=أريد استشارة قانونية"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 sm:bottom-6 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <WhatsAppIcon className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default FAQPage;
